export const SCALINATA_MOBILE_MAX_VIEWPORT_WIDTH = 767;
export const SCALINATA_FOOTER_BANNER_SIZE = 'mobileBanner';

export const getScalinataFooterBannerSize = ({
  enabled,
  viewportWidth,
}) => {
  if (!enabled) return null;
  if (!Number.isFinite(viewportWidth) || viewportWidth > SCALINATA_MOBILE_MAX_VIEWPORT_WIDTH) {
    return null;
  }
  return SCALINATA_FOOTER_BANNER_SIZE;
};

export const getScalinataFooterAdHeight = (bannerSize) => {
  if (bannerSize === 'mobileBanner') return 50;
  return 0;
};
